export const TRACK_PROP10 = 'TRACK_PROP10';
export const TRACK_EVENT = 'TRACK_EVENT';
export const TRACK_CLICK = 'TRACK_ClICK';
export type TrackingEventTypes = typeof TRACK_PROP10 | typeof TRACK_EVENT | typeof TRACK_CLICK;
export const TrackingEvents = new Set<TrackingEventTypes>([TRACK_PROP10, TRACK_EVENT, TRACK_CLICK]);

type TrackingArgs = {
  currentState: string,
  title: string,
};

export type Prop10Args = {
  trackLink: string,
  trackText?: string,
  page?: string,
  skipEvent: boolean,
  eventNumber?: string
} & TrackingArgs;

export type TrackingEventArgs = {
  eventNum: string,
  name?: string,
} & TrackingArgs;

export interface TrackAttr {
  prop10?: string;
  evar33?: string;
  prop15?: string;
  prop7?: string;
  evar29?: string;
  products?: string;
}

export class Prop10 implements Prop10Args {
  constructor(
    public trackLink: string,
    public currentState: string,
    public title: string,
    public trackText?: string,
    public page?: string,
    public skipEvent = false,
    public eventNumber?: string
  ) {
  }
}

export class OmnitureEvent implements TrackingEventArgs {
  constructor(
    public eventNum: string,
    public name?: string,
    public currentState = '',
    public title = ''
  ) {
  }
}

export type TrackingPropsArgs = {
  prop10: string;
  prop15: string;
  prop44: string; //recall vin
  prop51: string; //Recall titles
  prop53: string; //Recalls ids
  prop67: string;
  eVar33: string;
};

export type TrackingClickArgs = {
  props: TrackingPropsArgs
  trackEvent: string;
  trackDelay: string;
  trackLink: string;
  trackType: string;
}

export class OmnitureProps implements TrackingPropsArgs {
  prop10: string;
  prop15: string;
  prop44: string;
  prop51: string;
  prop53: string;
  prop67: string;
  eVar33: string;

  constructor({prop10 = '', prop15 = '', prop44 = '', prop51 = '', prop53 = '', prop67 = '', evar33 = ''} = {}) {
    this.prop10 = prop10;
    this.prop15 = prop15;
    this.prop44 = prop44;
    this.prop51 = prop51;
    this.prop53 = prop53;
    this.prop67 = prop67;
    this.eVar33 = evar33;
  }
}

export class OmnitureClick implements TrackingClickArgs {
  constructor(public props: OmnitureProps | TrackingPropsArgs, public trackType = '', public trackEvent = '', public trackDelay = '', public trackLink = '') {
  }
}

export const ctaTypes = {
  link: 'link',
  button: 'button',
  arrow: 'arrow',
  scroller: 'scroller',
  dropdown:'dropdown',
  input:'input'
};

export type CtaType = typeof ctaTypes[keyof typeof ctaTypes];

export const pageTypes = {
  myPlans: 'my plans',
  checkout: 'checkout',
  shop: 'shop',
  payment:'payment',
  cancel_review: 'cancel your plan',
  cancel_confirm: 'cancel confirmation'
};

export type PageType = typeof pageTypes[keyof typeof pageTypes];
